<template>
  <div class="app-container">
    <el-form
      :model="queryParams"
      ref="queryForm"
      :inline="true"
      v-show="showSearch"
      label-width="68px"
    >
          <el-form-item label="关键字" prop="deviceName">
        <el-input
          v-model="queryParams.deviceName"
          placeholder="请输入设备名称/IMEI/IMSI"
          clearable
          size="small"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="开始时间" prop="uploadTime">
        <el-date-picker
          clearable
          size="small"
          style="width: 200px"
          v-model="queryParams.uploadTime"
          type="date"
          value-format="yyyy/MM/dd"
          placeholder="选择开始时间"
        >
        </el-date-picker>
      </el-form-item>
       <el-form-item label="结束时间" prop="uploadTime">
        <el-date-picker
          clearable
          size="small"
          style="width: 200px"
          v-model="queryParams.endTime"
          type="date"
          value-format="yyyy/MM/dd"
          placeholder="选择结束时间"
        >
        </el-date-picker>
      </el-form-item>
      <!-- <el-form-item label="消息类型" prop="messageType">
        <el-select
          v-model="queryParams.messageType"
          placeholder="请选择消息类型"
          clearable
          size="small"
        >
          <el-option label="请选择字典生成" value="" />
        </el-select>
      </el-form-item>
      <el-form-item label="事件类型" prop="eventType">
        <el-select
          v-model="queryParams.eventType"
          placeholder="请选择事件类型"
          clearable
          size="small"
        >
          <el-option label="请选择字典生成" value="" />
        </el-select>
      </el-form-item>  -->
      <!-- <el-form-item label="设备SN" prop="deviceSn">
        <el-input
          v-model="queryParams.deviceSn"
          placeholder="请输入设备SN"
          clearable
          size="small"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="设备ID" prop="deviceId">
        <el-input
          v-model="queryParams.deviceId"
          placeholder="请输入设备ID"
          clearable
          size="small"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item> -->

      <el-form-item>
        <el-button
          type="cyan"
          icon="el-icon-search"
          size="mini"
          @click="handleQuery"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
          >重置</el-button
        >
      </el-form-item>
    </el-form>

    <!-- <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
        >新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="success"
          icon="el-icon-edit"
          size="mini"
          :disabled="single"
          @click="handleUpdate"
        >修改</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="danger"
          icon="el-icon-delete"
          size="mini"
          :disabled="multiple"
          @click="handleDelete"
        >删除</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="warning"
          icon="el-icon-download"
          size="mini"
          @click="handleExport"
        >导出</el-button>
      </el-col>
	  <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row> -->

    <el-table
      v-loading="loading"
      :data="aeprepoprtList"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column
        label="产品名称"
        :formatter="formatProduct"
        prop="productId"
        width="180"
      ></el-table-column>
      <el-table-column
        label="上报时间"
        align="center"
        prop="uploadTime"
        width="180"
      >
      </el-table-column>

      <el-table-column label="设备名称" align="center" prop="deviceName"/>
      <el-table-column label="IMEI" align="center" prop="imei" width="180"/>

      <!-- <el-table-column label="设备名称" align="center" prop="deviceName" /> -->
      <el-table-column label="服务" align="center" prop="formatServiceId" />
      <!-- <el-table-column label="租户ID" align="center" prop="tenantId" /> -->
      <!-- <el-table-column label="接入协议" align="center" prop="protocol" /> -->
      <!-- <el-table-column label="设备ID" align="center" prop="deviceId" /> -->
      <el-table-column
        label="消息类型"
        align="center"
        prop="messageType"
        :formatter="formatMsgType"
      />
      <el-table-column
        label="事件类型"
        align="center"
        prop="eventType"
        :formatter="formatEventType"
      />
      <el-table-column
        label="事件描述"
        align="center"
        prop="eventContent"
        width="200"
        :formatter="formatEventContent"
      />
      <!-- <el-table-column label="事件内容解析" align="center" prop="eventDecrypt" /> -->
      <el-table-column label="备注" align="center" prop="remark" />
      <el-table-column label="设备SN" align="center" prop="deviceSn" />
      <el-table-column label="IMSI" align="center" prop="imsi" />
      <!-- <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
            v-hasPermi="['aep:aeprepoprt:edit']"
          >修改</el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
            v-hasPermi="['aep:aeprepoprt:remove']"
          >删除</el-button>
        </template>
      </el-table-column> -->
    </el-table>

    <!-- <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.page"
      :limit.sync="queryParams.size"
      @pagination="getList"
    /> -->
    <div style="display: flex; justify-content: flex-end">
      <el-pagination
        background
        @current-change="currentChange"
        @size-change="sizeChange"
        layout="sizes, prev, pager, next, jumper, ->, total, slot"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { listAeprepoprt , listAepDeviceInfo} from "./aeprepoprt";

export default {
  name: "Aeprepoprt",
  components: {},
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // AEP设备上报信息表格数据
      aeprepoprtList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      aepDeviceInfoList:[],
      messageTypeOptions:[{}],
      // 查询参数
      queryParams: {
        page: 1,
        size: 10,
        uploadTime: null,
        messageType: null,
        eventType: null,
        eventContent: null,
        deviceSn: null,
        deviceId: null,
        deviceName: null,
        endTime:null
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        createdTime: [
          { required: true, message: "创建时间不能为空", trigger: "blur" },
        ],
        updatedTime: [
          { required: true, message: "创建时间不能为空", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    // thia.initDevice();
    this.getList();
  },
  
  methods: {
    initDevice(){
        listAepDeviceInfo().then((resp)=>{
          this.aepDeviceInfoList=resp.data;
        })
    },
    formatServiceId(row,col,cv,index){
      if(cv==1){
        return "业务数据上报";
      }
        return cv;
    },
    formatEventContent(row, col, cv, index) {
      if (cv == undefined || cv == null || cv == "") {
        return cv;
      }
      let data = JSON.parse(row.eventContent);
      let _text = "";
      for (let k in data) {
        if (k == "temperature") {
            _text+='温度：['+data[k]+'度]';
        }
        if (k == "temperature_state") {
           _text+=('状态：'+(data[k]==0?'正常':'温度过高'));
        }
        if(k=='error_code'){
          _text+=(data[k]==0?'正常':'传感器故障');
        }
        if(k=='tamper_alarm'){
           _text+=(data[k]==0?'设备安装':'设备拆除报警');
        }
      }
      return _text.length>0?_text:cv;
    },
    formatProduct(row, col, cv, index) {
      if (row.productId == "15013623") {
        return "GS424N温度报警器";
      }
      return "GS424N温度报警器";
    },
    formatMsgType(row, col, cv, index) {
      if (cv == "dataReport") {
        return "数据上报";
      }
      if (cv == "eventReport") {
        return "事件上报";
      }
      if (cv == "deviceOnlineOfflineReport") {
        return "设备上线/下线";
      }
      return cv;
    },
    formatEventType(row, col, cv, index) {
      if (row.messageType == "deviceOnlineOfflineReport") {
        if (cv == 1) {
          return "上线";
        }
        if (cv == 0) {
          return "下线";
        }
      }

      if (row.messageType == "dataReport") {
        if (row.serviceId == 1) {
          return "业务数据上报";
        }
        if (row.serviceId == 2) {
          return "信号数据上报";
        }
        if (row.serviceId == 3) {
          return "注册消息上报";
        }
      }

      if (row.messageType == "eventReport") {
        if (cv == 1) {
        }
        if (cv == 2) {
          return "温度过高报警";
        }
        if (cv == 3) {
          return "故障上报";
        }
        if (cv == 4) {
        }
      }
      return cv;
    },
    sizeChange(currentSize) {
      this.queryParams.size = currentSize;
      this.getList();
    },
    // 选择页
    currentChange(currentPage) {
      this.queryParams.page = currentPage;
      this.getList("advanced");
    },
    /** 查询AEP设备上报信息列表 */
    getList() {
      this.loading = true;
      let endTime = this.queryParams.endTime;
      if(endTime!=undefined && endTime!=null && endTime!=''){
        endTime=endTime.substring(0,10)+' 23:59:59';
        this.queryParams.endTime = endTime;
      }
      listAeprepoprt(this.queryParams).then((response) => {
        this.aeprepoprtList = response.list;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        uploadTime: null,
        serviceId: null,
        tenantId: null,
        protocol: null,
        messageType: null,
        eventType: null,
        eventContent: null,
        eventDecrypt: null,
        remark: null,
        deviceSn: null,
        deviceId: null,
        deviceName: null,
        imsi: null,
        imei: null,
        createdBy: null,
        createdTime: null,
        updatedBy: null,
        updatedTime: null,
      };
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      // this.resetForm("queryForm");
      this.queryParams={
        page: 1,
        size: 10,
        uploadTime: null,
        messageType: null,
        eventType: null,
        eventContent: null,
        deviceSn: null,
        deviceId: null,
        deviceName: null,
        endTime:null
      };
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.id);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加AEP设备上报信息";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {},
    /** 提交按钮 */
    submitForm() {},
    /** 删除按钮操作 */
    handleDelete(row) {},
    /** 导出按钮操作 */
    handleExport() {},
  },
};
</script>
